import { render, staticRenderFns } from "./partenr-account.vue?vue&type=template&id=21961ffa&scoped=true&"
import script from "./partenr-account.vue?vue&type=script&lang=js&"
export * from "./partenr-account.vue?vue&type=script&lang=js&"
import style0 from "./partenr-account.vue?vue&type=style&index=0&id=21961ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21961ffa",
  null
  
)

export default component.exports